/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetListAuditLogEntity } from '../models/GetListAuditLogEntity';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AuditLogsService {
  /**
   * List audit logs
   * @param startDate Start date (ISO8601)
   * @param endDate End date (ISO8601)
   * @param page Page number
   * @param limit Items per page
   * @param actorPhoneNumber Actor user phone number
   * @param action Action type
   * @returns GetListAuditLogEntity
   * @throws ApiError
   */
  public static auditlogControllerListAuditLogs(
    startDate: string,
    endDate: string,
    page?: string,
    limit?: string,
    actorPhoneNumber?: string,
    action?: string,
  ): CancelablePromise<GetListAuditLogEntity> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/v1/audit-logs',
      query: {
        page: page,
        limit: limit,
        actorPhoneNumber: actorPhoneNumber,
        action: action,
        startDate: startDate,
        endDate: endDate,
      },
      errors: {
        401: `Unauthorized`,
        500: `Internal server error`,
      },
    });
  }
}
